"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sprintf_js_1 = require("sprintf-js");
function gettext(localeObj = {}, msgid, argArrs = []) {
    const localeMessage = localeObj[msgid] || msgid || "";
    let result = msgid;
    try {
        result = (Array.isArray(argArrs) ? sprintf_js_1.vsprintf : sprintf_js_1.sprintf)(localeMessage, argArrs);
    }
    catch (e) {
        console.error("[sprintf]", msgid, e);
    }
    return result;
}
exports.gettext = gettext;
;
function curryGettext(localeObj = {}) {
    return (msgid, argArrs) => {
        return gettext(localeObj, msgid, argArrs);
    };
}
exports.curryGettext = curryGettext;
//# sourceMappingURL=gettext.js.map